module.exports = __webpack_public_path__ + "static/media/westinchennai01.9128dc66.jpg";